<svg
  class="perio-banda"
  [attr.viewBox]="'0 0 ' + ancho + ' ' + alto"
>
  <line class="cej" [attr.x1]="0" [attr.y1]="cejY" [attr.x2]="ancho" [attr.y2]="cejY" />

  <g class="regla">
    <line
      *ngFor="let r of reglaLineas()"
      [attr.x1]="0"
      [attr.y1]="r.y"
      [attr.x2]="ancho"
      [attr.y2]="r.y"
    />
    <text *ngFor="let r of reglaLineas()" [attr.x]="2" [attr.y]="r.y + 5">{{ r.mm }}</text>
  </g>

  <ng-container *ngFor="let fdi of fila; let idx = index">
    <g
      class="diente"
      [class.ausente]="!presente(fdi)"
      [class.clickable]="mode === 'edit' && presente(fdi)"
      (click)="onDiente(fdi)"
    >
      <path
        class="silueta"
        [attr.transform]="dienteTransform(fdi, idx)"
        [attr.d]="dientePath(fdi)"
      />
    </g>
  </ng-container>

  <polygon class="bolsa-fill" [attr.points]="poligonoBolsa()" />
  <polyline class="linea-bolsa" [attr.points]="puntosBolsa()" [attr.stroke]="colorBolsa" />
  <polyline class="linea-margen" [attr.points]="puntosMargen()" [attr.stroke]="colorMargen" />

  <circle
    *ngFor="let p of sangradoPuntos()"
    [attr.cx]="p.x"
    [attr.cy]="p.y"
    r="2.4"
    [attr.fill]="colorSangrado()"
  />
</svg>
